const getThermostatsList = (state) => state.thermostatsList;

export default {
  getThermostatsList,
};
